import './grid_tile_video_inline.less';

import React, { Component, Fragment } from 'react';
import autobind from 'class-autobind';

import { makeVideoishPlayerPropsForContent } from 'zoomforth_tools/videoish_player.js';
import VideoishPlayer from 'zoomforth_component_lib/videoish_player.jsx';
import GridTile from './grid_tile.jsx';
import GridTileInnerTypeImage from './grid_tile_inner_type_image.jsx';

const getCustomThumbnail = (contentItem) =>
  contentItem.croppedImageUrl || contentItem.uncroppedImageUrl;

class GridTileVideoInline extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isPlaying: false
    };

    autobind(this);
  }

  handleStartPlaying() {
    this.setState({ isPlaying: true });
  }


  render() {
    const {
      isPlaying
    } = this.state;

    const {
      captionData,
      contentItem,
      makeVideoishPlayerTrackingCallbacks
    } = this.props;

    return (
      <GridTile
        {...this.props}
        captionData={captionData}
        shouldHideTileCaption={isPlaying}
        hasVideoIcon={!isPlaying}
        onVideoPlayButtonClick={this.handleStartPlaying}
      >
        <div
          onClick={this.handleStartPlaying}
          className="tile-videoish-wrapper"
        >
          {!isPlaying ?
            <GridTileInnerTypeImage
              zfImage={this.props.tile_inner_zf_image}
              needsCrop={this.props.croppedImageUrl === null}
              altText={contentItem.alt_text}
              imageSrc={getCustomThumbnail(this.props)}
            />
          :
            <VideoishPlayer {...{
              ...makeVideoishPlayerPropsForContent(this.props, this.props.asset),
              ...makeVideoishPlayerTrackingCallbacks(contentItem),
              autoplay: true,
            }}
            />
          }
        </div>
      </GridTile>
    );
  }

}

export default GridTileVideoInline;
